/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */

Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.TimeLength = (function() {
  function TimeLength() {
    Monet.UI.Fields.TextField.apply(this, arguments);

    this.createBaseStructure();

    var getValueByReturnDataAsType = function(returnDataAs, value) {
      var type = returnDataAs;
      var valueFormatted;
      var date = new Monet.Date.GeneralFunctions();

      switch (type) {
        case "seconds":
          valueFormatted = new Monet.Format.SECONDS(value)
            .convertHourToSeconds()
            .getValue();
          break;
        default:
          valueFormatted = date.convertHourToMilliSeconds(value);
          break;
      }

      return valueFormatted;
    };

    this.createElement = function() {
      this.input = document.createElement("input");
      this.input.type = "text";

      if (this.maxSize) {
        this.input.maxLength = this.maxSize;
      }

      this.rootEl.className = "MonetUIFieldTimeLength";
      this.rootEl.appendChild(this.input, this.label);
    };

    this.getValue = function() {
      if (this.input) {
        this.value = this.input.value;
      }
      var valueFormatted = "";
      var options = this.getOptions();

      if (options) {
        valueFormatted = getValueByReturnDataAsType(
          options.returnDataAs,
          this.value
        );
      } else {
        valueFormatted = this.value;
      }

      return valueFormatted;
    };

    this.addListeners = function() {
      new Monet.Date.GeneralFunctions().setTimePicker(
        this.input,
        null,
        "HH:mm"
      );
    };

    this.render = function() {
      this.createElement();
      this.setInputValue();
      this.addListeners();
      return this.rootEl;
    };
  }

  return TimeLength;
})();
